import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useGetExpenceQuery, useGetExpenceStatisticsQuery, useRemoveExpenceMutation } from '../../redux/services/ExpenceService';
import { deleteConfirmation } from '../../utils';
import ExpenseCreateModal from '../ExpensePage/ExpenseCreateModal';
import ExpenseViewodal from '../ExpensePage/ViewModal';

const ExpenseStatistics = ({ id }) => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)


    const [removeRequest] = useRemoveExpenceMutation()


    const { data: data3, } = useGetExpenceStatisticsQuery(id)
    const { data: data2, isLoading, isFetching, refetch } = useGetExpenceQuery({ id: id, pagination: `?page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}` })
    const statistic = data3?.response?.data
    const jobs = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    return (
        <>
            <div className="single-data mt-2">
                {/* <h5 className="text-left">Jobs</h5> */}
                <div class="single-data mt-2">
                    <h4 class="text-left mb-4">Total Expense</h4>
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="card bg-primary tx-fixed-white card-bg-img">
                                <a class="card-body text-decoration-none position-relative d-flex justify-content-between">
                                    <div>
                                        <div class="flex-grow-1">
                                            <p class="mb-4 fs-18 fw-semibold text-white">Total Expense</p>
                                        </div><span class="fs text-white">{statistic?.total?.total} - ${statistic?.total?.amount || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                                </a>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="card bg-success tx-fixed-white card-bg-img">
                                <a class="card-body position-relative d-flex justify-content-between">
                                    <div>
                                        <div class="flex-grow-1">
                                            <p class="mb-4 fs-18 fw-semibold text-white">Monthly Expense</p>
                                        </div><span class="fs text-white">{statistic?.monthly?.total} - ${statistic?.monthly?.amount || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                                </a>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="card bg-warning tx-fixed-white card-bg-img">
                                <a class="card-body position-relative d-flex justify-content-between">
                                    <div>
                                        <div class="flex-grow-1">
                                            <p class="mb-4 fs-18 fw-semibold text-white">Weekly Expense</p>
                                        </div><span class="fs text-white">{statistic?.weekly?.total} - ${statistic?.weekly?.amount || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="row">
                    <div className="col-auto ms-auto">
                        <button className="btn bg-light text-capitalize">
                            Search By: <span className='text-success'>{searchBy?.split('_').join(' ')}</span>
                        </button>
                    </div>
                    <div className="col-lg-3 col-5 p-0 mb-3">
                        <div className="input-group m-0">
                            <input
                                className="form-control" type="text" placeholder="Search Here..."
                                aria-describedby="basic-addon1"
                                value={searchQuery}
                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                onChange={(e) => setSearchQuery(e.target?.value)}
                            />
                            <span
                                type="button"
                                onClick={() => handleSearchChange(searchQuery)}
                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                <i className="ri-search-line" />
                            </span>
                        </div>
                    </div>
                </div>

                <CustomPagination
                    isFetching={isFetching}
                    data={jobs}
                    total={total}
                    onChangePage={handlePageChange} // Handle page change
                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                    paginationDefaultPage={currentPage} // Set the current page

                    columns={[
                        {
                            name: 'ID',
                            selector: row => row.id,
                            sortable: true,
                            width: '70px',
                        },
                        {
                            selector: row => row?.driver?.full_name,
                            sortable: true,
                            name: (
                                <span
                                    onClick={() => handleSearchBy('driver_name')}
                                >
                                    {searchBy == 'driver_name' ? <b className='text-success'>Driver Name</b> : 'Driver Name'}
                                </span>
                            )
                        },
                        {
                            name: 'Start Date',
                            selector: row => row.start,
                            sortable: true,
                        },
                        {
                            name: 'End Date',
                            selector: row => row.end,
                            sortable: true,
                        },
                        {
                            selector: row => row.type,
                            sortable: true,
                            name: (
                                <span
                                    onClick={() => handleSearchBy('type')}
                                >
                                    {searchBy == 'type' ? <b className='text-success'>Expense Type</b> : 'Expense Type'}
                                </span>
                            )
                        },
                        {
                            name: 'Expense Description',
                            selector: row => row.description,
                            sortable: true,
                        },
                        {
                            name: 'Expense Amount ($)',
                            selector: row => row.amount,
                            sortable: true,
                        },
                        {
                            name: 'Create Date & Time',
                            selector: row => row.created_at,
                            sortable: true,
                        },
                        {
                            name: 'Actions',
                            cell: (row, i) => {
                                return (
                                    <div className="hstack gap-1 fs-1">
                                        <Button
                                            onClick={() => handleEdit(row)}
                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                        >
                                            <i className="ri-edit-line" />
                                        </Button>

                                        <Button
                                            onClick={() => handleView(row)}
                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                        >
                                            <i className="ri-eye-line" />
                                        </Button>
                                        <a
                                            aria-label="delete"
                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                        >
                                            <i className="ri-delete-bin-7-line" />
                                        </a>
                                    </div>
                                )
                            },
                            ignoreRowClick: true,
                            allowOverflow: true,
                            button: true,
                            width: '220px'
                        },
                    ]}
                />
            </div>


            {isShow && (
                <ExpenseCreateModal
                    show={isShow}
                    handleClose={() => {
                        setIsShow(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}

            {isView && (
                <ExpenseViewodal
                    show={isView}
                    handleClose={() => {
                        setIsView(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}
        </>
    )
}

export default ExpenseStatistics